export * from '@hive/platform-url-schema'

export const URL_PAGE_TEST_SENTRY_ERROR = 'test-sentry-error'
export const URL_PAGE_SHOPS = '/shops'

export const URL_PAGE_PRODUCT_GROUP = '/product-groups/:productGroupId'

// TODO: From old code, need to refactor

export const URL_BIND_PAYMENT_METHOD = '/profile/bind-payment-method'
export const URL_SHOP_PREFIX = '/'
export const URL_REQUEST_DELIVERY_FEEDBACK = '/delivery-feedback'

export const URL_PAGE_HOW_WE_WORK = '/how-we-work'
export const URL_PAGE_PARTNERS = '/partners'
export const URL_PAGE_LEGAL_INFO = '/legal'
export const URL_PAGE_RETURNS = '/returns'
export const URL_PAGE_PERSONAL_DATA = '/personal_data'
export const URL_PAGE_DELETE_INSTRUCTIONS = '/delete_instructions'
export const URL_PAGE_CONSENT = '/consent'

export const URL_VERIFY_PAYMENT = '/verify-payment'

export const URL_PAGE_PRODUCTS = '/products'
export const URL_PAGE_SINGLE_PRODUCT = '/products/:productSlug'


// Устаревшие роуты для редиректов
export const URL_LEGACY_CATEGORY_PREFIX = 'category'
export const URL_LEGACY_CATEGORY = `/${URL_LEGACY_CATEGORY_PREFIX}`
export const URL_LEGACY_CATEGORY_SLUG = `/${URL_LEGACY_CATEGORY_PREFIX}/:categorySlug`
export const URL_LEGACY_CATEGORY_CHILDREN = `/${URL_LEGACY_CATEGORY_PREFIX}/:categorySlug/:categoryChildrenSlug`
export const URL_LEGACY_CATEGORY_SUB_CHILDREN = `/${URL_LEGACY_CATEGORY_PREFIX}/:categorySlug/:categoryChildrenSlug/:categorySubChildrenSlug`

export const URL_OFFLINE = '/common/offline'

export const URL_ANY = '*'
